import Tooltip from '~/components/RedesignedTooltip';

import styles from './styles.js';

const Pill = ({
  color,
  classes,
  children,
  tooltipMessage,
  className,
  ...props
}) => {
  const allClasses = classnames(classes.root, classes[color], className);

  const contents = (
    <div className={allClasses} {...props}>
      {children}
    </div>
  );

  if (tooltipMessage) {
    return (
      <Tooltip title={tooltipMessage} style={{ cursor: 'pointer' }}>
        {contents}
      </Tooltip>
    );
  }

  return contents;
};

Pill.propTypes = {
  color: PropTypes.oneOf(['blue', 'orange', 'green']),
};

export default withStyles(styles)(Pill);
